import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {notFound_template} from "../components/templates/notFound_template";

declare var ko: any;
declare var page: any;

export class notFound extends vnModule_knockoutJS{

    protected notfound: notFound_template;

    protected getModuleName(){
        return "notFound";
    }

    buildContent() : Array<Element>{

        this.notfound = new notFound_template( "notFound", this.viewModel, this );

        return [ this.notfound.build()];
    }

    public fillPage() : void{
    }
}


// WEBPACK FOOTER //
// ./js/modules/notFound.ts